export const usuario = () => {
    return {
        iniciales: 'PM',
        nombreCompleto: 'Pedro Muñoz',
        correo: 'pedromuñoz@copec.cl',
        perfil: 'Administrador',
        permissions: {
            adminManual: true,
            imageDelete: true,
            imageSelect: true,
            tooltipEdit: true,
            imageDescription: true
        }
    }
}
